import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/apiConfig';

function ProductHomePageSectionDropdown({
  onChangeDropdown,
  showLabel = true,
  isDisabled,
  selectedValue,
  isClearable = true,
}) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchSections = async () => {
      try {
        const baseUrl = getApiBaseUrl();
        if (!baseUrl) return;
        const response = await axios.get(`${baseUrl}/ec-product-homepage-section/getActive`);
        if (response.status === 200 && response.data?.data) {
          const list = response.data.data || [];
          const mapped = list.map((section) => ({
            value: section.ProductHomePageSectionId?.toString(),
            label: section.SectionName || `Section ${section.ProductHomePageSectionId}`,
            raw: section,
          }));
          setOptions(mapped);
          if (selectedValue) {
            const match = mapped.find((m) => m.value === selectedValue?.toString());
            setSelectedOption(match || null);
          }
        }
      } catch (err) {
        console.error('Failed to load home page sections', err);
      }
    };
    fetchSections();
  }, [selectedValue]);

  useEffect(() => {
    if (!selectedValue) {
      setSelectedOption(null);
      return;
    }
    const match = options.find((m) => m.value === selectedValue?.toString());
    setSelectedOption(match || null);
  }, [selectedValue, options]);

  const handleChange = (option) => {
    setSelectedOption(option);
    if (onChangeDropdown) {
      onChangeDropdown(option);
    }
  };

  return (
    <div className="mb-0">
      {showLabel ? <label className="form-label">Homepage Section</label> : null}
      <Select
        classNamePrefix="sk-product-homepage-section"
        value={selectedOption}
        options={options}
        onChange={handleChange}
        isClearable={isClearable}
        isDisabled={isDisabled}
        menuPlacement="auto"
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />
    </div>
  );
}

export default ProductHomePageSectionDropdown;
